import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appCharactersOnly]'
})
export class CharactersOnlyDirective {

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedChars = /^[A-Za-z]+$/;
    const isDash = event.key === '-';
    const isSpace = event.key === ' ';
    const isSpecialKey = /^(Backspace|Tab|ArrowDown|ArrowLeft|ArrowRight|ArrowUp|Delete)$/.test(event.key);

    if (!allowedChars.test(event.key) && !isDash &&!isSpace && !isSpecialKey) {
      event.preventDefault();
    }
  }
}
